import { createFileRoute } from "@tanstack/react-router";

import { productSearchParamsSchema } from "@/domain/product";
import { ProductsScreen } from "@/interactors/ProductsScreen";
import { headWithCustomTitle, validateRoutePermission } from "@/utils/router";

export const Route = createFileRoute("/_authed/admin/products/")({
  component: ProductsScreen,
  beforeLoad: ({ context }) =>
    validateRoutePermission({
      context,
      action: "list",
      subject: "products",
    }),
  head: () => headWithCustomTitle("main:products.title"),
  validateSearch: productSearchParamsSchema,
});
